import { PageSection, PageSectionVariants, TextContent, Text, Alert, Form, FormGroup, TextInput, TextArea } from '@patternfly/react-core';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { fetchLabeling, StoreState } from '../../store/reducers';

import './about-page.css';
import { DISPLAY_VERSION, getDefaultAppName } from '../../environments';
import { useTranslation } from 'react-i18next';


const AboutPage = () => {

    // reload labeling whenever the page is reloaded
    const dispatch = useDispatch();
    const { t } = useTranslation();

    useEffect(() => {
        dispatch(fetchLabeling());
    }, [dispatch]);

    const productLabel = useSelector((state: StoreState) => state.productLabel);
    const productLabelError = useSelector((state: StoreState) => state.productLabelError);
    const appVersion = useSelector((state: StoreState) => state.appVersion);
    const appConfig = useSelector((state: StoreState) => state.appConfig);

    // print version information to console when about page is opened
    useEffect(() => {
        if (productLabel) {
            console.log(productLabel);
        }
        if (appVersion) {
            console.log(appVersion);
        }
    }, [appVersion, productLabel]);

    return (
        <>
            <PageSection variant={PageSectionVariants.default}>
                <TextContent>
                    <Text component="h1">{t('page.about.title')}</Text>
                </TextContent>
            </PageSection>

            {appConfig && appConfig.showErrorsInUi && productLabelError !== null && (
                <PageSection>
                    <Alert variant="danger" isInline title="An error occurred when trying to retrieve labeling information">
                        <p>An error occurred when trying to retrieve labeling information:</p>
                        <p>{productLabelError}</p>
                    </Alert>
                </PageSection>
            )}

            <PageSection variant={PageSectionVariants.light}>
                {productLabel !== null && (
                    <PageSection variant={PageSectionVariants.light} className="limit-width">
                        <div className="labeling">
                            <TextContent className="main-info">
                                <Text component="h2">{productLabel.manufacturerModelName}</Text>
                                <Text component="p">{productLabel.manufacturer}</Text>
                                {productLabel.description && (<Text component="p" className="description">{productLabel.description}</Text>)}
                            </TextContent>

                            <Form isHorizontal>
                                <FormGroup
                                    data-test='about'
                                    data-testid='udi'
                                    label="UDI"
                                    fieldId="udi-readonly" >
                                    <TextInput value={productLabel.udi || ''} type="text" isReadOnly id="udi-readonly" />
                                </FormGroup>
                                <FormGroup
                                    data-test='about'
                                    data-testid='labeling'
                                    label="Labeling"
                                    fieldId="labeling-readonly" >
                                    <TextArea
                                        readOnly
                                        id="labeling-readonly"
                                        value={productLabel.labelingAsString}
                                        resizeOrientation='vertical'
                                        className="text-editor-area"
                                        spellCheck="false"
                                        rows={8}
                                    />
                                </FormGroup>
                                {appVersion && (
                                    <FormGroup
                                        data-test='about'
                                        data-testid='app-version'
                                        label={getDefaultAppName()}
                                        fieldId="app-version-readonly" >
                                        <TextInput value={`${DISPLAY_VERSION} (${appVersion.commit})`} type="text" isReadOnly id="app-version-readonly" />
                                    </FormGroup>
                                )}
                            </Form>
                        </div>
                    </PageSection>
                )}
            </PageSection>
        </>
    );
}

export default AboutPage;